/**
 * MultiplayerPlayerInfoPanel
 * Thin wrapper connecting shared PlayerInfoPanel with game-state-store.
 */

import type { Augmentation } from "@cloudnest/augmented-chess-engine";
import { useGameState } from "../game-state-store";
import { PlayerInfoPanel } from "./PlayerInfoPanel";

interface MultiplayerPlayerInfoPanelProps {
  onAugmentationClick: (augmentation: Augmentation) => void;
}

export function MultiplayerPlayerInfoPanel({
  onAugmentationClick,
}: MultiplayerPlayerInfoPanelProps): JSX.Element | null {
  const { gameState } = useGameState();

  if (!gameState) return null;

  return (
    <PlayerInfoPanel
      gameState={gameState}
      onAugmentationClick={onAugmentationClick}
    />
  );
}
